export default __webpack_public_path__ + "static/media/cards.a6697b98.svg";